import React, { Component } from "react";

import Header from "./Header";
import PageFoot from "./PageFoot";
import Body from "./Body";

import Config from "../config/Config";
// import Cache from "./Cache";

// import WidgetAjax from "../widget/WidgetAjax";

import "./../css/common.css";
import "./../css/base.css";
import "./../css/frame.css";
import "./../css/project.css";

class Frame extends Component {
  constructor(props) {
    super(props);

    this.state = {
      basePath: Config.getBasePath(),
      titleNodes: [
        { name: "home", title: "首页" }
      
      ],
      leftNode: [
        { name: "demo", title: "Demo", path: "/home/demo" }
      ],
      privileges: [
        { name: "demo", title: "Demo", path: "/home/demo" }
       
      ],
      leftNodes: {
        home:[
          { name: "demo", title: "Demo", path: "/home/demo" }
        ]
      },
      nodes: undefined,
      systemTitle: "全国个体工商户“名特优新”申报系统",
      titleActiveKey: "",
      leftActiveKey: "",
      menuPaths: [],
    };

    this.leftOnSelect = this.leftOnSelect.bind(this);
    this.headerOnSelect = this.headerOnSelect.bind(this);
    this.freshPage = this.freshPage.bind(this);
    this.redrict = this.redrict.bind(this);
    this.myRef = this;
    this.getRenderInfo = null;
  }

  static getDerivedStateFromProps(props, state) {
    /**
    * 通过path查找节点
    * @param {*} nodes
    * @param {*} path
    * @param {*} item 当前节点
    * @param {*} isRecurse 是否需要递归查找
    * @returns
    */
     const findNodeByNodes = (nodes, path, item, isRecurse) => {
      let node = null;
  
      if (nodes !== undefined && nodes.length > 0) {
        for (let i = 0; i < nodes.length; i++) {
          if (item !== undefined && item !== null && item !== "") {
            if (
              nodes[i].name !== undefined &&
              item !== undefined &&
              item !== null &&
              nodes[i].name === item.name
            ) {
              node = nodes[i];
            } else if (nodes[i].subcomponents !== undefined && isRecurse === true) {
              node = findNodeByNodes(nodes[i].subcomponents, path, item, true);
            }
          } else {
            if (
              nodes[i].path !== undefined &&
              (nodes[i].path === path ||
                "/" + nodes[i].path === path ||
                "/" + nodes[i].path + "/" === path ||
                nodes[i].path + "/" === path)
            ) {
              node = nodes[i];
            } else if (nodes[i].subcomponents !== undefined && isRecurse === true) {
              node = findNodeByNodes(nodes[i].subcomponents, path, item, true);
            }
          }
  
          if (node !== null) {
            break;
          }
        }
  
        return node;
      }
    }
    const nodeProps = props.children.props
    const { titleNodes, leftNodes, privileges } = state;

    let { titleActiveKey } = state;

    let path = "",
      node,
      item;

    if (nodeProps !== undefined && nodeProps.match !== undefined) {
      path = nodeProps.match.path;
    }

    if (
      nodeProps !== undefined &&
      nodeProps.location !== undefined &&
      nodeProps.location.state !== undefined
    ) {
      item = nodeProps.location.state.node;
    }

    if (path !== undefined && path !== null && path !== "") {
      node = findNodeByNodes(privileges, path, item, true);

      if (node !== undefined && node !== null) {
        let frameNode = findNodeByNodes(titleNodes, path, node, false);

        if (frameNode !== undefined && frameNode !== null) {
          let leftNode = leftNodes[frameNode.name];
          
          // this.setState({
          //   leftNode: leftNode,
          //   titleActiveKey: frameNode.name,
          //   leftActiveKey: frameNode.name
          // })
          state["leftNode"] = leftNode;
          state["titleActiveKey"] = frameNode.name;
          state["leftActiveKey"] = frameNode.name;

          return { node: frameNode, leftNode: leftNode, titleActiveKey: frameNode.name };
        }

        for (let key in leftNodes) {
          frameNode = findNodeByNodes(leftNodes[key], path, node, true);

          if (frameNode !== undefined && frameNode !== null) {
            titleActiveKey = key;
            break;
          }
        }

        if (frameNode !== undefined && frameNode !== null) {
          let leftNode = leftNodes[titleActiveKey];

          // this.setState({
          //   leftNode: leftNode,
          //   titleActiveKey: titleActiveKey,
          //   leftActiveKey: frameNode.name
          // })

          state["leftNode"] = leftNode;
          state["titleActiveKey"] = titleActiveKey;
          state["leftActiveKey"] = frameNode.name;
        } else {
          // this.setState({
          //   titleActiveKey: undefined,
          //   leftActiveKey: node.name
          // })
          state["titleActiveKey"] = undefined;
          state["leftActiveKey"] = node.name;
        }
      } else {
        if (!item) return;
        let leftNode = state.leftNodes[item.name];
        // this.setState({
        //   leftNode: leftNode,
        //   titleActiveKey: item.name
        // })
        state["leftNode"] = leftNode;
        state["titleActiveKey"] = item.name;
      }
    }
    return state
  }

  componentDidMount() {}

  /**
   * 头部菜单选择后回调函数
   * @param {*} key
   */
  headerOnSelect(key) {
    if (!key) return;
    key = typeof key == "string" ? key : key.key;
    let { titleNodes } = this.state;

    let menuPaths = [];

    let leftNode = this.state.leftNodes[key];

    menuPaths.push(key);

    this.setState({ leftNode, titleActiveKey: key, menuPaths: menuPaths });

    for (let item of titleNodes) {
      if (item.name === key) {
        let state = {
          node: item,
          item: item,
          children: leftNode,
        };

        this.redrict(item.path, state, false);
      }
    }
  }

  leftOnSelect(key, path, keyPaths) {
    let { menuPaths, titleNodes } = this.state;

    let showHeaderArea = Config.isShowHeaderArea();

    if (
      showHeaderArea !== true ||
      titleNodes === undefined ||
      titleNodes === null ||
      titleNodes.length === 0
    ) {
      menuPaths = [];
    }

    menuPaths.push(...keyPaths);

    this.setState({ leftActiveKey: key, menuPaths: menuPaths });

    this.props.children.props.history.push({ pathname: path, state: { pathData: key } });
  }

  freshPage() {
    window.location.reload(); //刷新页面
  }

  redrict(path, state, isFresh) {
    this.props.children.props.history.push({ pathname: path, state: state });

    if (isFresh !== undefined && isFresh !== false) {
      this.freshPage();
    }
  }

  getRender(){
    const { titleNodes, systemTitle, menuPaths } = this.state;

    // this.findNode(this.props.children.props);

    let { leftNode, titleActiveKey } = this.state;

    const { model } = this.props;

    if (model === "home") {
      let state = { children: leftNode };

      if (
        this.props.children.props.location !== undefined &&
        this.props.children.props.location.state !== undefined
      ) {
        state = { ...this.props.children.props.location.state, ...state };
      }

      this.props.children.props.history.push({
        pathname: this.props.children.props.match.path,
        state: state,
      });
    }

    const childrenBody = React.Children.map(this.props.children, (child) =>
      React.cloneElement(child, { reload: this.reload })
    );
    switch (model) {
      case "page": {
        return (
          <div className="sf-page">
            <Body>{childrenBody}</Body>
          </div>
        );
      }
      case "table": {
        return (
          <div className="sf-table-page">
            {/* <Header headerOnSelect={this.headerOnSelect} titleNode={titleNodes} leftNode= {leftNode} 
                            menuPaths={menuPaths} location={this.props.children.props.location}
                            systemTitle={systemTitle} activeKey={titleActiveKey} freshPage={this.freshPage} redrict={this.redrict}  /> */}
            {/* <Left
              leftNode={leftNode}
              disposalData={disposalData}
              leftActiveKey={leftActiveKey}
              redrict={this.redrict}
              leftOnSelect={this.leftOnSelect}
              history={this.props.children.props.history}
              location={this.props.children.props.location}
            /> */}
            <Body>{childrenBody}</Body>
          </div>
        );
      }
      case "home": {
        return (
          <div className="sf-page">
            <Body>{childrenBody}</Body>
          </div>
        );
      }
      default: {
        return (
          <div className="sf-normal">
            <Header
              headerOnSelect={this.headerOnSelect}
              titleNode={titleNodes}
              leftNode={leftNode}
              menuPaths={menuPaths}
              location={this.props.children.props.location}
              systemTitle={systemTitle}
              activeKey={titleActiveKey}
              freshPage={this.freshPage}
              redrict={this.redrict}
            />
            <div className="sg-center">
              <Body>{childrenBody}</Body>
              <PageFoot></PageFoot>
            </div>
          </div>
        );
      }
    }
  }

  render() {
    return <div>{this.getRender()}</div>;
  }
}

export default Frame;
